export interface TaskStatus {
  // key: string;
  value: TaskStatusEnum;
  icon?: string;
  label?: string;
}

export enum TaskStatusEnum {
  Pending = 'pending',
  Ongoing = 'ongoing',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export const TASK_STATUSES: TaskStatus[] = [
  { value: TaskStatusEnum.Pending, label: 'Nog te doen', icon: 'flag' },
  { value: TaskStatusEnum.Ongoing, label: 'Lopend', icon: 'hourglass_top' }, // hourglass_top, assist_walker
  { value: TaskStatusEnum.Completed, label: 'Afgerond', icon: 'check' },
  { value: TaskStatusEnum.Cancelled, label: 'Geannuleerd', icon: 'close' },
];

export function getTaskStatusses(): TaskStatus[] {
  return (
    TASK_STATUSES
  );
}

export function getTaskStatusLabel(key?: string): string {
  return (
    TASK_STATUSES.find((s) => s.value === key)?.label ?? 'Onbekende status'
  );
}

export function getTaskStatusIcon(key?: string): string {
  return (
    TASK_STATUSES.find((s) => s.value === key)?.icon ?? 'info'
  );
}
